// @flow
// The doctor's own switch for the record's rich-text editor, only in its rollout (advancedData.richTextEditor.access).
// On the Formulários page, outside its plan gate: a plan can have the editor without custom forms (clinic_limited).
import React, { useCallback } from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Toggle } from '@elements';
import { setRichTextEditorEnabled } from '@context/user';
import { useRichTextEditor, mapRichTextEditorSaving } from '@helpers/connect';
import { useTranslationNs } from '@helpers/helpers';
import './RichTextEditorSetting.scss';

const RichTextEditorSetting = () => {
  const [_] = useTranslationNs('settings');
  const dispatch = useDispatch();
  const richTextEditor = useRichTextEditor();
  const isDoctor = useSelector((state) => get(state, ['context', 'user', 'roleType']) === 'Doctor');

  // One switch at a time: off while one is being saved (the store says so, for the page opened again too)
  const saving = useSelector(mapRichTextEditorSaving);
  const handleToggle = useCallback(({ value }) => {
    if (saving) return;
    dispatch(setRichTextEditorEnabled(value));
  }, [dispatch, saving]);

  if (!isDoctor || !richTextEditor.access) return null;

  return (
    <div className="centerContent richTextEditorSetting">
      <div className="toolbar dashed">
        <h1>{_('label/rich_text_editor/title')}</h1>
      </div>
      <Toggle
        name="richTextEditor"
        label={_('label/rich_text_editor/switch')}
        description={_('label/rich_text_editor/description')}
        isChecked={richTextEditor.enabled}
        disabled={saving}
        onChange={handleToggle}
      />
    </div>
  );
};

export default RichTextEditorSetting;
